// extracted by mini-css-extract-plugin
export default {"container":"NP-z","topReviewHeading":"OP-z","criticalReview":"PP-z","favorableReview":"QP-z","vsSeparator":"RP-z"};